// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ColumnConfigurator styles - Excel-style column configuration modal
 */

.column-configurator-modal .ant-modal-content {
  border-radius: 8px;
  max-height: calc(100vh - 48px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.column-configurator-modal .ant-modal-body {
  overflow-y: auto;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-height: 0;
}

.column-configurator-modal .ant-modal-header {
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 24px;
}

.column-configurator-modal .ant-modal-title {
  font-size: 16px;
  font-weight: 600;
}

.column-configurator-modal .ant-modal-footer {
  border-top: 1px solid #e8e8e8;
  padding: 12px 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.column-configurator-modal .ant-modal-footer .ant-btn:first-child {
  margin-right: auto;
}

.column-configurator {
  padding: 8px 0;
}

.pinned-columns-info {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #666;
}

.pinned-columns-info .anticon {
  margin-right: 8px;
  color: #999;
}

.column-panels {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 8px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.column-panel {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  min-width: 200px;
}

.panel-header {
  padding: 10px 12px;
  font-weight: 600;
  font-size: 13px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}

.panel-header .column-count {
  font-weight: normal;
  color: #888;
}

.panel-search {
  margin: 8px;
  width: calc(100% - 16px);
}

.panel-search .ant-input {
  font-size: 13px;
}

.column-list {
  height: 300px;
  overflow-y: auto;
  padding: 4px;
}

.column-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 13px;
  -webkit-transition: background-color 0.15s ease;
  transition: background-color 0.15s ease;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
}

.column-item .column-name {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.column-item:hover {
  background: #f0f0f0;
}

.column-item.selected {
  background: #e6f4ff;
  border: 1px solid #91caff;
  margin: -1px;
}

.column-item.pinned-left {
  background: #fff7e6;
  border-left: 3px solid #fa8c16;
  padding-left: 9px;
}

.column-item.pinned-right {
  background: #f0f5ff;
  border-right: 3px solid #1890ff;
  padding-right: 9px;
}

.column-item.column-item-locked {
  background: #fafafa;
  border-left: 3px solid #faad14;
  padding-left: 9px;
  opacity: 0.85;
}

.column-item.column-item-locked:hover {
  background: #fafafa;
}

.column-item.pinned-left.selected,
.column-item.pinned-right.selected {
  border-width: 1px;
  border-style: solid;
}

.column-item.pinned-left.selected {
  border-color: #fa8c16;
  border-left-width: 3px;
}

.column-item.pinned-right.selected {
  border-color: #1890ff;
  border-right-width: 3px;
}

/* Pin controls */

.pin-controls {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 2px;
  opacity: 0;
  -webkit-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
  margin-left: auto;
}

.column-item:hover .pin-controls {
  opacity: 1;
}

.pin-controls.pinned {
  opacity: 1;
}

.pin-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  color: #666;
  padding: 0;
  font-size: 12px;
}

.pin-btn:hover {
  background: #e0e0e0;
  color: #333;
}

.unpin-btn {
  color: #999;
  font-size: 10px;
}

.unpin-btn:hover {
  background: #ffccc7;
  color: #cf1322;
}

.pin-indicator {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 2px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 3px;
}

.pin-indicator.pin-left {
  background: #fff7e6;
  color: #d46b08;
  border: 1px solid #ffd591;
}

.pin-indicator.pin-right {
  background: #f0f5ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.pin-indicator .anticon {
  font-size: 10px;
}

.column-index {
  color: #999;
  font-size: 12px;
  min-width: 24px;
}

.empty-message {
  text-align: center;
  color: #999;
  padding: 40px 20px;
  font-size: 13px;
}

.transfer-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 8px;
  padding-top: 60px;
}

.transfer-buttons .ant-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.reorder-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 8px;
  padding-top: 60px;
}

.reorder-buttons .ant-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.configurator-hint {
  margin-top: 12px;
  font-size: 12px;
  color: #888;
  text-align: center;
}

/* Scrollbar styling for column lists */

.column-list::-webkit-scrollbar {
  width: 6px;
}

.column-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.column-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.column-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
`, "",{"version":3,"sources":["webpack://./components/PacsAgGrid/ColumnConfigurator.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,iBAAiB;;AACjB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,sCAA8B;EAA9B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,uCAAuC;;AACvC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\r\n * ColumnConfigurator styles - Excel-style column configuration modal\r\n */\r\n\r\n.column-configurator-modal .ant-modal-content {\r\n  border-radius: 8px;\r\n  max-height: calc(100vh - 48px);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.column-configurator-modal .ant-modal-body {\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.column-configurator-modal .ant-modal-header {\r\n  border-bottom: 1px solid #e8e8e8;\r\n  padding: 16px 24px;\r\n}\r\n\r\n.column-configurator-modal .ant-modal-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.column-configurator-modal .ant-modal-footer {\r\n  border-top: 1px solid #e8e8e8;\r\n  padding: 12px 24px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.column-configurator-modal .ant-modal-footer .ant-btn:first-child {\r\n  margin-right: auto;\r\n}\r\n\r\n.column-configurator {\r\n  padding: 8px 0;\r\n}\r\n\r\n.pinned-columns-info {\r\n  background: #f5f5f5;\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 4px;\r\n  padding: 8px 12px;\r\n  margin-bottom: 16px;\r\n  font-size: 13px;\r\n  color: #666;\r\n}\r\n\r\n.pinned-columns-info .anticon {\r\n  margin-right: 8px;\r\n  color: #999;\r\n}\r\n\r\n.column-panels {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.column-panel {\r\n  flex: 1;\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  min-width: 200px;\r\n}\r\n\r\n.panel-header {\r\n  padding: 10px 12px;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  background: #fafafa;\r\n  border-bottom: 1px solid #e8e8e8;\r\n  border-radius: 6px 6px 0 0;\r\n}\r\n\r\n.panel-header .column-count {\r\n  font-weight: normal;\r\n  color: #888;\r\n}\r\n\r\n.panel-search {\r\n  margin: 8px;\r\n  width: calc(100% - 16px);\r\n}\r\n\r\n.panel-search .ant-input {\r\n  font-size: 13px;\r\n}\r\n\r\n.column-list {\r\n  height: 300px;\r\n  overflow-y: auto;\r\n  padding: 4px;\r\n}\r\n\r\n.column-item {\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  transition: background-color 0.15s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.column-item .column-name {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.column-item:hover {\r\n  background: #f0f0f0;\r\n}\r\n\r\n.column-item.selected {\r\n  background: #e6f4ff;\r\n  border: 1px solid #91caff;\r\n  margin: -1px;\r\n}\r\n\r\n.column-item.pinned-left {\r\n  background: #fff7e6;\r\n  border-left: 3px solid #fa8c16;\r\n  padding-left: 9px;\r\n}\r\n\r\n.column-item.pinned-right {\r\n  background: #f0f5ff;\r\n  border-right: 3px solid #1890ff;\r\n  padding-right: 9px;\r\n}\r\n\r\n.column-item.column-item-locked {\r\n  background: #fafafa;\r\n  border-left: 3px solid #faad14;\r\n  padding-left: 9px;\r\n  opacity: 0.85;\r\n}\r\n\r\n.column-item.column-item-locked:hover {\r\n  background: #fafafa;\r\n}\r\n\r\n.column-item.pinned-left.selected,\r\n.column-item.pinned-right.selected {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n\r\n.column-item.pinned-left.selected {\r\n  border-color: #fa8c16;\r\n  border-left-width: 3px;\r\n}\r\n\r\n.column-item.pinned-right.selected {\r\n  border-color: #1890ff;\r\n  border-right-width: 3px;\r\n}\r\n\r\n/* Pin controls */\r\n.pin-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n  margin-left: auto;\r\n}\r\n\r\n.column-item:hover .pin-controls {\r\n  opacity: 1;\r\n}\r\n\r\n.pin-controls.pinned {\r\n  opacity: 1;\r\n}\r\n\r\n.pin-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 22px;\r\n  height: 22px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  color: #666;\r\n  padding: 0;\r\n  font-size: 12px;\r\n}\r\n\r\n.pin-btn:hover {\r\n  background: #e0e0e0;\r\n  color: #333;\r\n}\r\n\r\n.unpin-btn {\r\n  color: #999;\r\n  font-size: 10px;\r\n}\r\n\r\n.unpin-btn:hover {\r\n  background: #ffccc7;\r\n  color: #cf1322;\r\n}\r\n\r\n.pin-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  padding: 2px 6px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.pin-indicator.pin-left {\r\n  background: #fff7e6;\r\n  color: #d46b08;\r\n  border: 1px solid #ffd591;\r\n}\r\n\r\n.pin-indicator.pin-right {\r\n  background: #f0f5ff;\r\n  color: #1890ff;\r\n  border: 1px solid #91d5ff;\r\n}\r\n\r\n.pin-indicator .anticon {\r\n  font-size: 10px;\r\n}\r\n\r\n.column-index {\r\n  color: #999;\r\n  font-size: 12px;\r\n  min-width: 24px;\r\n}\r\n\r\n\r\n.empty-message {\r\n  text-align: center;\r\n  color: #999;\r\n  padding: 40px 20px;\r\n  font-size: 13px;\r\n}\r\n\r\n.transfer-buttons {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding-top: 60px;\r\n}\r\n\r\n.transfer-buttons .ant-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.reorder-buttons {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding-top: 60px;\r\n}\r\n\r\n.reorder-buttons .ant-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.configurator-hint {\r\n  margin-top: 12px;\r\n  font-size: 12px;\r\n  color: #888;\r\n  text-align: center;\r\n}\r\n\r\n/* Scrollbar styling for column lists */\r\n.column-list::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.column-list::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.column-list::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.column-list::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
